<div class="location-picker">
  <div #mapEl class="map"></div>

  <div class="flex items-center justify-between gap-3 mt-2 text-sm flex-wrap">
    <div class="text-gray-600">
      @if (currentLat !== null && currentLng !== null) {
        <span class="font-medium">Lat:</span> {{ currentLat }}
        <span class="ml-3 font-medium">Lng:</span> {{ currentLng }}
      } @else {
        <span class="text-gray-400 italic">Click the map to set a location</span>
      }
    </div>

    <div class="flex items-center gap-2">
      <button type="button" (click)="useCurrentLocation()"
              [disabled]="isLocating"
              class="px-3 py-1.5 text-xs font-medium border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50">
        {{ isLocating ? 'Locating...' : 'Use my location' }}
      </button>
      @if (currentLat !== null) {
        <button type="button" (click)="clear()"
                class="px-3 py-1.5 text-xs font-medium text-red-600 border border-red-200 rounded-lg hover:bg-red-50 transition-colors">
          Clear
        </button>
      }
    </div>
  </div>
</div>
